import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  quote: string;
  image?: string;
}
export function TestimonialCard({
  name,
  age,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-amber-100 hover:shadow-md transition-shadow duration-300" data-id="element-25">
      <div className="flex gap-1 mb-4" data-id="element-26">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-27" />)}
      </div>
      <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-28">"{quote}"</p>
      <div className="flex items-center gap-3" data-id="element-29">
        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold text-sm" data-id="element-30">
          {name.charAt(0)}
        </div>
        <div data-id="element-31">
          <p className="font-semibold text-gray-900" data-id="element-32">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-33">{age} años, Mamá</p>
        </div>
      </div>
    </div>;
}